import axios from 'axios';

const baseUrl = '/api';
const WS_BASE_URL = 'wss://ai.zcsh.top'

export async function login() {
  try {
    const formData = new FormData();
    formData.append('username', 'testUser');
    formData.append('password', '123456');

    const response = await axios.post(`${baseUrl}/login`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    throw new Error('Login failed');
  }
}

export async function getTemplatesByMode(modeType, token) {
  try {
    const response = await axios.get(`${baseUrl}/get_templates_by_mode`, {
      params: { mode_type: modeType },
      headers: { Authorization: `bearer ${token}` }
    });
    console.log(response.status);
    if (response.status !== 200) {
      return response.status;
    }
    return response.data.result.data;
  } catch (error) {
    // 检查错误对象中是否有响应，并返回状态码
    if (error.response) {
      console.log(error.response.status);
      return error.response.status;
    }
    // 如果没有响应对象，抛出一个新的错误
    throw new Error('Network response was not ok');
  }
}

export async function getStorySettings(token) {
  try {
    const response = await axios.get(`${baseUrl}/storysettings`, {
      headers: { Authorization: `bearer ${token}` }
    });
    return response.data.result.data;
  } catch (error) {
    throw new Error('Failed to fetch story settings');
  }
}

export async function createStorySetting(data, token) {
  try {
    const response = await axios.post(`${baseUrl}/storysettings`, data, {
      headers: { 
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}` 
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to create story setting');
  }
}

export async function updateStorySetting(storySettingId, data, token) {
  try {
    const response = await axios.put(`${baseUrl}/storysetting/${storySettingId}`, data, {
      headers: { 
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}` 
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to update story setting');
  }
}

export async function deleteStorySetting(storySettingId, token) {
  try {
    const response = await axios.delete(`${baseUrl}/storysetting/${storySettingId}`, {
      headers: { Authorization: `bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to delete story setting');
  }
}

export function generateUniqueId() {
  const timestamp = Date.now().toString();
  const randomNum = Math.random().toString(36).substr(2, 9);
  return `${timestamp}-${randomNum}`;
}


export function initializeWebSocket(token) {
  const client_id = generateUniqueId(); // 生成唯一的client_id
  const BASE_URL = `${WS_BASE_URL}/ws/generate_script/${client_id}`; // 加上client_id
  const ws = new WebSocket(BASE_URL);
  return ws;
}

export function sendMessage(ws, person, elements, templates, storysettings, worldviews, genres, characterdesigns, model, token) {
  let storedFree = localStorage.getItem('free');
  if (!storedFree) {
    storedFree = "自由写作，发挥你的想象力";
  }
  const message = {
    user_id: 505,
    type: 'confirm',
    person: person,
    elements: elements,
    templates: templates,
    storysettings: storysettings,
    worldviews: worldviews,
    genres: genres,
    characterdesigns: characterdesigns,
    id: generateUniqueId(), // 请求ID
    free: storedFree,
    model: model,
  };

  ws.send(JSON.stringify(message));
  console.log('Message sent:', message);
}

